import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * List allows a dataset to be traversed and rendered in a list format.  A render function allows for the current data item to be used to generate more complex presentations.
 *
 */
function List(_ref) {
  let {
    items = [],
    render = item => item,
    bordered = false,
    condensed = false,
    expanded = false,
    striped = false,
    hover = false,
    inline = false,
    nolistdecoration = false,
    // deprecated
    decorated = true,
    className,
    ...rest
  } = _ref;
  const liClassName = clsx({
    'list-bordered': bordered,
    'list-condensed': condensed,
    'padding-vertical-2': expanded,
    'list-striped': striped,
    'list-hover': hover,
    'display-inline-flex align-items-center': inline,
    'no-list-decoration': nolistdecoration || !decorated
  });
  const ulClassName = clsx({
    list: true,
    'list-inline display-inline-block margin-bottom-0': inline
  }, className);
  if (!items.length) {
    return null;
  }
  const renderedItems = items.map((item, index) => /*#__PURE__*/_jsx("li", {
    className: liClassName
  }, item?.key ?? index, render(item)));
  return /*#__PURE__*/React.createElement("ul", Object.assign({
    "data-cmp": "list",
    className: ulClassName
  }, rest), renderedItems);
}
export default List;